export default "__VITE_ASSET__1f2d6158__"